var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("MatchMedia", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ mobile }) {
          return [
            _c(
              "div",
              { staticClass: "header" },
              [
                _c(
                  "div",
                  { staticClass: "left" },
                  [
                    mobile
                      ? _c("el-button", {
                          attrs: { icon: "el-icon-more", type: "text" },
                          on: { click: _vm.onClickMenu },
                        })
                      : _c("div", { staticClass: "logo-container" }, [
                          _c("img", {
                            attrs: {
                              src: "/logo.png",
                              alt: "Madrileña red de gas",
                            },
                            on: { click: _vm.onClickLogo },
                          }),
                          _c("span", { staticClass: "version" }, [
                            _vm._v("v" + _vm._s(_vm.version)),
                          ]),
                        ]),
                  ],
                  1
                ),
                _c("Searcher-SearchBar", { staticClass: "center" }),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    !mobile ? _c("Auth-SelectUserGroup") : _vm._e(),
                    _c("User-UserMenu"),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }